import React, { useEffect, useState } from 'react';
import SelectDepartments from '../../maps/SelectDepartments';
import { bbox } from '@turf/turf';
import { locales } from '../../../../translations/locales';
import { _setText } from '../../../../controllers/dom';

const SigData = (props) => {
    const { locale, theme, mapObject, selectDepartment, departments, deleteDepartment } = props;
    const [deletedDepartment, setDeletedDepartment] = useState(false);

    const askDeleteDepartment = (dept) => {
        if (deletedDepartment) return setDeletedDepartment(false);
        setDeletedDepartment(dept);
    };

    const getDeptGeoJson = (dept, multiple) => {
        if (!dept) return;

        if (mapObject.getLayer('department-fill')) mapObject.removeLayer('department-fill');
        if (mapObject.getLayer('department-label')) mapObject.removeLayer('department-label');
        if (mapObject.getSource('department')) mapObject.removeSource('department');

        if (mapObject.getSource('department' + dept)) {
            return;
        }

        fetch(`https://api.alertes-speciales.fr/geojson/departement/${dept}?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
            .then((response) => response.json())
            .then((geojson) => {
                // Ajouter la source GeoJSON avec un ID correct
                mapObject.addSource(multiple ? 'department' + dept : 'department', {
                    type: 'geojson',
                    data: geojson,
                });

                // Ajouter le layer de remplissage
                mapObject.addLayer({
                    id: multiple ? 'department-fill' + dept : 'department-fill',
                    type: 'fill',
                    source: multiple ? 'department' + dept : 'department',
                    layout: {},
                    paint: {
                        'fill-color': '#088',
                        'fill-opacity': 0.5,
                    },
                });

                // Ajouter le label du département
                mapObject.addLayer({
                    id: multiple ? 'department-label' + dept : 'department-label',
                    type: 'symbol',
                    source: multiple ? 'department' + dept : 'department',
                    layout: {
                        'text-field': ['get', 'nom'],
                        'text-size': 14,
                        'text-anchor': 'center',
                        'visibility': 'visible',
                        'text-font': ['Noto Sans Regular'],
                    },
                    paint: {
                        'text-color': '#ffffff',
                        'text-halo-color': '#000000',
                        'text-halo-width': 2,
                    },
                });
                _setText(dept, geojson.properties.nom);
                mapObject.fitBounds(bbox(geojson), { padding: 50 }, { maxZoom: 10 });
            })
            .catch((error) => console.error(`Erreur lors du chargement du département ${dept}:`, error));
    };

    useEffect(() => {
        if (departments.length > 0 && mapObject) {
            if (!mapObject.loaded()) {
                mapObject.on('load', () => {
                    departments.forEach((department) => {
                        getDeptGeoJson(department, true);
                    });
                });
            } else {
                departments.forEach((department) => {
                    getDeptGeoJson(department, true);
                });
            }
        }
    }, [departments, mapObject, deletedDepartment]);

    return (
        <div>
            <h1>{locales[locale].sig.data}</h1>
            {
                departments.map((department, index) => (
                    <div key={index} className='badge badge-primary m-1 p-2'>
                        <span id={department}>
                            {department}
                        </span>
                        <button className='btn btn-sm btn-danger p-0 pl-1 pr-1 ml-1' onClick={() => askDeleteDepartment(department)}>
                            X
                        </button>
                    </div>
                ))
            }
            <SelectDepartments getDeptGeoJson={getDeptGeoJson} departments={departments} />
            <button className='btn btn-primary' onClick={selectDepartment}>
                {locales[locale].sig.validDepartment}
            </button>
            {
                deletedDepartment && (
                    <div className="card container p-0 gameInformations mt-5 mb-2">
                        <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                            <div>
                                {locales[locale].sig.deleteDepartmentConfirm}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setDeletedDepartment(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-building'
                                    onClick={() => {
                                        deleteDepartment(deletedDepartment);
                                        setDeletedDepartment(false);
                                    }}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default SigData;
